// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { Dispatch } from 'redux';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { trackEvent } from '../../tracking/actions';
import { clickoutRequest } from '../../Serp/actions';
import { getFeaturedAd, getIsExpiredFeaturedAd } from '../selectors';
import { VERTICAL_NAMES } from '../../common/constants/common';
import { featuredAdImpressionEvent } from '../../tracking/events';
import SectionTypes from '../../tracking/SectionTypes';
import SectionIds from '../../tracking/SectionIds';
import ExpiredAd from '../../Serp/components/ExpiredAd/container';
import HomesFeaturedAd from '../homes';
import CarsFeaturedAd from '../cars';
import { getVerticalName, getCountryCode, getReadingDirection } from '~/common/selectors/config';

type Props = {
  ad: ?Object,
  isExpired: boolean,
  countryCode: string,
  readingDirection: string,
  verticalName: VerticalName,
  intl: IntlShape,
  trackEvent: Function,
  clickoutRequest: Function,
};

class Component extends React.Component<Props> {
  componentDidMount() {
    // Launch impression tracking
    if (this.props.ad) {
      this.props.trackEvent(featuredAdImpressionEvent());
    }
  }

  handleItemClick = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (this.props.ad) {
      this.props.clickoutRequest(
        this.props.ad,
        SectionIds.SECTION_RETENTION_FEATURED,
        SectionTypes.SECTION_TYPE_ORGANIC
      );
    }
  };

  render() {
    const { verticalName, isExpired } = this.props;

    if (isExpired) {
      return <ExpiredAd />;
    }

    switch (verticalName) {
      case VERTICAL_NAMES.homes: {
        return <HomesFeaturedAd {...this.props} handleItemClick={this.handleItemClick} />;
      }
      case VERTICAL_NAMES.cars: {
        return <CarsFeaturedAd {...this.props} handleItemClick={this.handleItemClick} />;
      }
      default: {
        return null;
      }
    }
  }
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return {
    trackEvent: event => dispatch(trackEvent(event)),
    clickoutRequest: featuredAd => dispatch(clickoutRequest(featuredAd)),
  };
}

function mapStateToProps(state: Object) {
  return {
    ad: getFeaturedAd(state),
    isExpired: getIsExpiredFeaturedAd(state),
    verticalName: getVerticalName(state),
    countryCode: getCountryCode(state),
    readingDirection: getReadingDirection(state),
  };
}

const FeaturedAdHomesContainer = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Component);

FeaturedAdHomesContainer.displayName = 'FeaturedAdHomesContainer';

export default FeaturedAdHomesContainer;



// WEBPACK FOOTER //
// ./app/FeaturedAd/shared/container.js